/**
 * S3 Configuration for prescription ingestion
 */
export const S3_CONFIG = {
  BUCKET_NAME: "erx-pipe-staging-json-messages",
  KEY_PREFIX: "inbound/qa_apaq_portal",
  AWS_ACCOUNT: "pillpack-erx-beta",

  /**
   * Get the full S3 path
   */
  getFullPath(): string {
    return `s3://${this.BUCKET_NAME}/${this.KEY_PREFIX}/`;
  },

  /**
   * Get the full S3 URL for a specific file
   */
  getFileUrl(fileName: string): string {
    return `s3://${this.BUCKET_NAME}/${this.KEY_PREFIX}/${fileName}`;
  }
} as const;

/**
 * UPMS Configuration for prescription ingestion
 */
export const UPMS_CONFIG = {
  SENDER_ID: "657332",
  FROM_IDENTIFIER: "6633950178005",
  FROM_QUALIFIER: "D",
  TO_QUALIFIER: "P",
  // Transmission channels by message type
  TRANSMISSION_CHANNELS: {
    NEW_RX: "ESCRIBE",
    TRANSFER_RX: "ORTF",
    RENEWAL_RX: "ESCRIBE",
  },
  // eScribe network — sent on renewal (eScribe/SureScripts) messages
  ESCRIBE_NETWORK: "SURESCRIPTS",
  // Complete pharmacy object - constant for all requests
  PHARMACY: {
    identification: {
      ncpdpId: "5919177",
      npi: "1285084467"
    },
    businessName: "Amazon.com - Amazon Pharmacy Nationwide Home Delivery",
    address: {
      addressLine1: "4500 S Pleasant Vly Rd Ste 201",
      city: "Austin",
      stateProvince: "TX",
      postalCode: "78744",
      countryCode: "US"
    },
    communicationNumbers: {
      primaryTelephone: { number: "8552063605" },
      fax: [{ number: "5128845981" }],
      homeTelephone: { number: "8552063605" }
    }
  }
} as const;
